import React from 'react';

const Deals = () => {
    document.title = 'Deals - Knowledge Haven';
    return (
        <div>
            <h1>Deals</h1>
        </div>
    );
};

export default Deals;